const anchors = document.querySelectorAll('.navigation__list');

//function for scroll
function scrollToPosition(id) {
    event.preventDefault();
    const target = document.getElementById(id);
    var offSetValue = 0;
    if(screen.width <= 960) {
        offSetValue = 210;
    }
    else {
        offSetValue = 110;
    }
    const scrollToElement = target.getBoundingClientRect().top + window.scrollY - offSetValue;
    if(target) {
        window.scrollTo({ top: scrollToElement });
    }
}

//Set scroll function to <a> element
anchors.forEach(anchor => {
    const headerId = anchor.href.split('#')[1];
    anchor.addEventListener('click', () => {
        scrollToPosition(headerId);
    })
});

const tabsDesktop = document.querySelectorAll('#list-container-desktop li');
const tabsMobile = document.querySelectorAll('#list-container-mobile li');

//Set active tabs for desktop
tabsDesktop.forEach(tab => {
    tab.addEventListener('click', function(event) {
        tabsDesktop.forEach(tab => tab.classList.remove('active-li-desktop'));
        this.classList.add('active-li-desktop');
    });
});

//Set active tabs for mobile
tabsMobile.forEach(tab => {
    tab.addEventListener('click', function(event) {
        tabsMobile.forEach(tab => tab.classList.remove('active-li-mobile'));
        this.classList.add('active-li-mobile');
    });
});